// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f5f5f5;
    background-image: url(bg02.jpg);background-size: cover;
    font-family: 'Arial, sans-serif';
    margin: 0;
} */

.container {
    text-align: center;
}


.box{    
    width: 100%;
    height: auto;
    position: relative;
    margin: auto;
    text-align: center;
    padding: 20px 0px 20px 0px;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 20px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
	
.content{
	text-transform: uppercase;
	 animation: 0.5s ease-out 0s 1 slideInDown;
}
.box, .login-box, .sign_up-box, .content-container{
	 animation: 0.5s ease-out 0s 1 slideInUp;
}
	
@keyframes slideInFadein {
    0% {opacity: 0;}
    100% {opacity: 1;}
}
@keyframes slideInUp {
    0% {transform: translateY(20px);opacity: 0;}
    100% {transform: translateY(0);opacity: 1;}
}
@keyframes slideInDown {
    0% {transform: translateY(-20px);opacity: 0;}
    100% {transform: translateY(0);opacity: 1;}
}	
	
	
	
	
.box button{ width: 80%;
    margin: 10px auto;
}
	
.first-page-button {
    padding: 10px 20px;
    margin: 10px;
    font-size: 16px;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    color: #fff;
}

.login-button {
    background-color: #DCC1B5;
}

.signup-button {
    background-color: #DCC1B5;
}


`, "",{"version":3,"sources":["webpack://./src/components/firstpage.css"],"names":[],"mappings":"AAAA;;;;;;;;;;GAUG;;AAEH;IACI,kBAAkB;AACtB;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,0CAA0C;IAC1C,mBAAmB;IACnB,uCAAuC;AAC3C;;AAEA;CACC,yBAAyB;EACxB,yCAAyC;AAC3C;AACA;EACE,uCAAuC;AACzC;;AAEA;IACI,IAAI,UAAU,CAAC;IACf,MAAM,UAAU,CAAC;AACrB;AACA;IACI,IAAI,2BAA2B,CAAC,UAAU,CAAC;IAC3C,MAAM,wBAAwB,CAAC,UAAU,CAAC;AAC9C;AACA;IACI,IAAI,4BAA4B,CAAC,UAAU,CAAC;IAC5C,MAAM,wBAAwB,CAAC,UAAU,CAAC;AAC9C;;;;;AAKA,aAAa,UAAU;IACnB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":["/* body {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    background-color: #f5f5f5;\n    background-image: url(bg02.jpg);background-size: cover;\n    font-family: 'Arial, sans-serif';\n    margin: 0;\n} */\n\n.container {\n    text-align: center;\n}\n\n\n.box{    \n    width: 100%;\n    height: auto;\n    position: relative;\n    margin: auto;\n    text-align: center;\n    padding: 20px 0px 20px 0px;\n    background-color: rgba(255, 255, 255, 0.8);\n    border-radius: 20px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\t\n.content{\n\ttext-transform: uppercase;\n\t animation: 0.5s ease-out 0s 1 slideInDown;\n}\n.box, .login-box, .sign_up-box, .content-container{\n\t animation: 0.5s ease-out 0s 1 slideInUp;\n}\n\t\n@keyframes slideInFadein {\n    0% {opacity: 0;}\n    100% {opacity: 1;}\n}\n@keyframes slideInUp {\n    0% {transform: translateY(20px);opacity: 0;}\n    100% {transform: translateY(0);opacity: 1;}\n}\n@keyframes slideInDown {\n    0% {transform: translateY(-20px);opacity: 0;}\n    100% {transform: translateY(0);opacity: 1;}\n}\t\n\t\n\t\n\t\n\t\n.box button{ width: 80%;\n    margin: 10px auto;\n}\n\t\n.first-page-button {\n    padding: 10px 20px;\n    margin: 10px;\n    font-size: 16px;\n    border-radius: 5px;\n    border: none;\n    cursor: pointer;\n    color: #fff;\n}\n\n.login-button {\n    background-color: #DCC1B5;\n}\n\n.signup-button {\n    background-color: #DCC1B5;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
